export type InputComponentWidth =
  | 'xxlarge'
  | 'xlarge'
  | 'large'
  | 'medium'
  | 'small'
  | 'dialog'
  | 'auto'
  | number;

export enum MuiChartType {
  BAR = 'BAR',
  STACKED_BAR = 'STACKED_BAR',
  PIE = 'PIE',
  DONUT = 'DONUT',
}
